import { render, staticRenderFns } from "./OngoingTransportIcon.vue?vue&type=template&id=151f2c14&"
import script from "./OngoingTransportIcon.vue?vue&type=script&lang=js&"
export * from "./OngoingTransportIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports